import React, { useState } from 'react'
// import { QrScanner } from '@yudiel/react-qr-scanner'
// import { QrReader } from 'react-qr-reader'
import QrReader from 'react-qr-reader2'
import { CustomButton } from 'components'
import success from 'images/succesScanTL.svg'
import fail from 'images/failScanTL.svg'
import permission from 'images/microphone.svg'
import './index.styl'

const getTicketCategoryLabel = (ticketType, fallback) => {
  switch (ticketType) {
    case 'TABLES':
      return 'Tables'
    case 'GENERAL_ADMITION':
      return 'General Admission'
    default:
      return fallback
  }
}

const QRReader = ({ onScan, scanning, response, setStatus, camera, handleNextScan, ticketCategoryName }) => {
  const [isActive, setIsActive] = useState(false)
  // const timeoutRef = useRef(null)

  // const setActiveScanner = () => {
  //  timeoutRef.current = setTimeout(() => setIsActive(false), 30000)
  // }

  const handleScan = (data, error) => {
    if (data && !scanning) {
      // clearTimeout(timeoutRef.current)
      // setActiveScanner()
      onScan(data)
    }
    // if (!!error) {
    //   setStatus({ status: 'permission', message: 'scanner not connected' })
    // }
  }
  const handleActive = () => {
    setIsActive(true)
    // setActiveScanner()
  }
  const handleError = () => setStatus({ status: 'permission', message: 'scanner not connected' })
  const icons = { success, fail, permission }
  const scanData = response?.status === 'success' && response?.data
  return (
    <div className='mainContainer'>
      <div className='readerContainer'>
        {isActive && (
          <div>
            <QrReader
              className='qrReader'
              // // videoStyle={{ width: '100%', height: 530, objectFit: 'cover' }}
              // // containerStyle={{ height: 430, objectFit: 'cover', width: '100%' }}
              style={{ width: '100%', height: 530, objectFit: 'cover' }}
              facingMode={camera}
              onError={handleError}
              onScan={handleScan}
              delay={200}
            />

          </div>
        )}
        <div className='readerWrapper'>
          <div className={`readerWindow${scanData ? ' hasDetails' : ''}`}>
            {response && (
              <div className='response-status'>
                <div className='response-container'>
                  <img src={icons[response?.status]} alt='icon' className='status-icon' />
                  {scanData && (
                    <>
                      <span className='scan-name'>{scanData.name}</span>
                      <div className='scan-details'>
                        <div className='scan-detail'>
                          <span className='scan-detail-label'>Section:</span>
                          <span className='scan-detail-value'>{scanData.section || '—'}</span>
                        </div>
                        <div className='scan-detail'>
                          <span className='scan-detail-label'>Ticket Category</span>
                          <span className='scan-detail-value'>{getTicketCategoryLabel(scanData?.ticketCategory?.ticketType, ticketCategoryName) || '—'}</span>
                        </div>
                        <div className='scan-detail'>
                          <span className='scan-detail-label'>Table #</span>
                          <span className='scan-detail-value'>{scanData.table || '—'}</span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {!isActive && (
              <div className='response-status'>
                <div className='response-container' onClick={handleActive}>
                  <span className='response-message'>Tap here for start scanning</span>
                </div>
              </div>
            )}
            <span className='lTop' />
            <span className='rTop' />
            <span className='rBottom' />
            <span className='lBottom' />
          </div>
          {response && (
            <CustomButton className='nextScanBtn' text='Next Scan' type='dark' onClick={handleNextScan} />
          )}
        </div>
      </div>
    </div>
  )
}

export default QRReader
